export const KIEN_NGHI_KIEM_TOAN = {
  KTNN_XU_LY_TAI_CHINH: 'KTNN_XU_LY_TAI_CHINH',
  KTNN_XU_LY_CO_CHE_CHINH_SACH: 'KTNN_XU_LY_CO_CHE_CHINH_SACH',
  KTNN_XU_LY_KIEM_DIEM_XU_LY_TRACH_NHIEM: 'KTNN_XU_LY_KIEM_DIEM_XU_LY_TRACH_NHIEM',
  KTNN_XU_LY_KHAC: 'KTNN_XU_LY_KHAC',
  KTNN_CHAN_CHINH_RUT_KINH_NGHIEM: 'KTNN_CHAN_CHINH_RUT_KINH_NGHIEM'
}

export const TYPE_DOCUMENT = {
  XU_LY_KET_QUA_THUC_HIEN: 'XU_LY_KET_QUA_THUC_HIEN',
  BAO_CAO_KET_QUA_THUC_HIEN: 'BAO_CAO_KET_QUA_THUC_HIEN'
}

export type FilterKeys =
  | 'EQUAL'
  | 'NOT_EQUAL'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL'
  | 'CONTAIN'
  | 'NOT_CONTAIN'
export const OPERATORS: Record<FilterKeys, string> = {
  EQUAL: 'Bằng',
  NOT_EQUAL: 'Không bằng',
  GREATER_THAN: 'Lớn hơn',
  GREATER_THAN_OR_EQUAL: 'Lớn hơn hoặc bằng',
  LESS_THAN: 'Nhỏ hơn',
  LESS_THAN_OR_EQUAL: 'Nhỏ hơn hoặc bằng',
  CONTAIN: 'Chứa',
  NOT_CONTAIN: 'Không chứa'
}
